<template>
  <div class="dod24" ref="dod24">
    <div class="dod24_content">
      <div class="dod24_text"
        ref="text"
        v-bind:style="`background-image: url(${require('@/assets/images/dod/texture_0009.jpg')})`"
      >
        <span
          v-for="(line, index) of splitText"
          v-bind:key="index"
          v-text="line"/>
      </div>
    </div>
  </div>
</template>

<script>
import anime from 'animejs'

export default {
  name: 'Day23',

  data: () => ({
    text: 'カタカナ語が苦手な方は「組見本」と呼ぶとよいでしょう。この組見本は自由に複製したり頒布することができます。書体やレイアウトなどを確認するために用います。主に書籍やウェブページなどのデザインを作成する時によく使われます。これは正式な文章の代わりに入れて使うダミーテキストです。この組見本は自由に複製したり頒布することができます。カタカナ語が苦手な方は「組見本」と呼ぶとよいでしょう。本文用なので使い方を間違えると不自然に見えることもありますので要注意。書体やレイアウトなどを確認するために用います。この組見本は自由に複製したり頒布することができます。'
  }),

  computed: {
    splitText() {
      return [...this.text]
    }
  },

  methods: {
  },

  mounted() {
    anime({
      targets: '.dod24_text span',
      color: [
        { value: 'rgba(255,255,255,0)' },
        { value: 'rgba(255,255,255,1)' },
        { value: 'rgba(255,255,255,0)' }
      ],
      duration: 1000,
      loop: true,
      delay: anime.stagger(100, {
        grid: [this.splitText.length / 10, 5],
        from: 'center'
      }),
      easing: 'easeInOutQuad'
    })
  }
}
</script>

<style scoped lang="scss">
.dod24 {
  @include FR_FULLSIZE;
  background-color: #111111;
}

.dod24_content {
  @include FR_FULLSIZE;
  @include FR_FLEX_LAYOUT(center, center, false, column);
}

.dod24_text {
  font-size: 3vmin;
  line-height: 1.5;
  font-style: normal;
  font-weight: bold;
  -webkit-background-clip: text;
  background-clip: text;
  background-repeat: no-repeat;
  background-color: transparent;
  background-size: cover;
  background-position: top center;
  background-image: linear-gradient(180deg, #FC466B 0%, #3F5EFB 100%);
  color: transparent;
  width: 80%;
  overflow: hidden;

  // 文字幅いっぱいに
  text-align: justify;
  text-justify: inter-ideograph;
  overflow-wrap: break-word;

  @supports (font-feature-settings: 'palt' 1) {
    font-feature-settings: 'palt' 1;
    letter-spacing: 0.05em;
  }

  @include FR_MQ_ONLY(QS) {
    font-size: 3.5vmin;
    width: 84%;
  }
}

.dod24_text span {
  display: inline;
  color: rgba(255,255,255,0);
}
</style>
